var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M36.488 26.579a1.734 1.734 0 010 2.46h.008l-.381.38-2.712-2.215.625-.625a1.741 1.741 0 012.46 0zm-6.45-2.125V5.745c0-.965-.777-1.741-1.742-1.741s-1.742.776-1.742 1.741V21.61l3.483 2.845zM14.445 11.717v-1.77l3.991 3.99a1.734 1.734 0 002.46 0 1.74 1.74 0 000-2.46l-6.952-6.965a1.734 1.734 0 00-2.46 0L8.81 7.184c.225.137.444.291.653.462l4.983 4.07zm-9.695-.478l-.24.239a1.734 1.734 0 000 2.46 1.74 1.74 0 002.46 0l.488-.487-2.708-2.212zm6.212 5.075v18.458c0 .965.776 1.741 1.741 1.741.965 0 1.742-.776 1.742-1.741V19.159l-3.483-2.845zm21.056 17.202l-2.49 2.49a1.734 1.734 0 01-2.46 0l-6.966-6.967a1.74 1.74 0 010-2.46 1.734 1.734 0 012.46 0l3.991 3.991v-1.519l5.465 4.465z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.153,
    y: 5.108,
    width: 45,
    height: 2.979,
    rx: 1.489,
    transform: "rotate(39.248 4.153 5.108)",
    fill: "#fff"
  })));
}
export default SvgClearSort;